

// import axios from 'axios';
// import { API_BASE_URL } from '../config';
// import { refreshAccessToken } from './api';
// import Cookies from 'js-cookie';
// import store from '../store';
// import { getStoredCoords } from '../hooks/useClientGeoLocation';

// // Create axios instance
// const api = axios.create({
//   baseURL: API_BASE_URL,
//   withCredentials: true,
// });

// // Track if a token refresh is in progress
// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach(prom => {
//     if (error) {
//       prom.reject(error);
//     } else {
//       prom.resolve(token);
//     }
//   });
  
//   failedQueue = [];
// };

// // Add a request interceptor
// api.interceptors.request.use(
//   (config) => {
//     const token = Cookies.get('access_token') || store.getState().auth.token;
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Add a response interceptor
// api.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;
    
//     // If the error is 401 and we haven't already tried to refresh
//     if (error.response?.status === 401 && !originalRequest._retry) {
      
//       // If refresh is already in progress, queue this request
//       if (isRefreshing) {
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ resolve, reject });
//         }).then(token => {
//           originalRequest.headers.Authorization = `Bearer ${token}`;
//           return api(originalRequest);
//         }).catch(err => {
//           return Promise.reject(err);
//         });
//       }
      
//       originalRequest._retry = true;
//       isRefreshing = true;
      
//       try {
//         const newToken = await refreshAccessToken();
//         if (newToken) {
//           // Update all queued requests with new token
//           processQueue(null, newToken);
          
//           // Retry the original request with the new token
//           originalRequest.headers.Authorization = `Bearer ${newToken}`;
//           return api(originalRequest);
//         } else {
//           // Refresh failed, clear queue and redirect
//           processQueue(new Error('Token refresh failed'));
//           window.location.href = '/accounts';
//           return Promise.reject(error);
//         }
//       } catch (refreshError) {
//         processQueue(refreshError);
//         window.location.href = '/accounts';
//         return Promise.reject(refreshError);
//       } finally {
//         isRefreshing = false;
//       }
//     }
    
//     return Promise.reject(error);
//   }
// );

// api.interceptors.request.use((config) => {
//   const coords = getStoredCoords();
//   if (coords?.lat != null && coords?.lng != null) {
//     config.headers['X-Client-Lat'] = coords.lat;
//     config.headers['X-Client-Lng'] = coords.lng;
//   }
//   return config;
// });

// export default api;


import axios from 'axios';
import { API_BASE_URL } from '../config';
import { refreshAccessToken } from './api';
import Cookies from 'js-cookie';
import store from '../store';
import { getStoredCoords } from '../hooks/useClientGeoLocation';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Track if a token refresh is in progress
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Add a request interceptor — auth token
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('access_token') || store.getState().auth.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a request interceptor — client geolocation (browser GPS, if granted)
api.interceptors.request.use((config) => {
  try {
    const coords = getStoredCoords();
    if (coords?.lat != null && coords?.lng != null) {
      config.headers['X-Client-Lat'] = coords.lat;
      config.headers['X-Client-Lng'] = coords.lng;
    }
  } catch {
    // never let geo-header logic break unrelated requests
  }
  return config;
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {

      // If refresh is already in progress, queue this request
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshAccessToken();
        if (newToken) {
          // Update all queued requests with new token
          processQueue(null, newToken);

          // Retry the original request with the new token
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        } else {
          // Refresh failed, clear queue and redirect
          processQueue(new Error('Token refresh failed'));
          window.location.href = '/accounts';
          return Promise.reject(error);
        }
      } catch (refreshError) {
        processQueue(refreshError);
        window.location.href = '/accounts';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;